import { CSSResultGroup, TemplateResult, html, SVGTemplateResult } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-social-icons.css.lit';
import '../../base/outline-link/outline-link';
import '../../base/outline-icon/outline-icon';
import { SlotController } from '../../../components/controllers/slot-controller';
// import { getBasePath } from '../../../utilities/base-path';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';

/**
 * The IdbSocialIcons component
 * @element idb-social-icons
 * @todo make this component more flexible
 * @todo write a Story
 */
@customElement('idb-social-icons')
export class IdbSocialIcons extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, false);

  private icons = {
    facebook: `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.02 23.88C4.32 22.86 0 17.94 0 12 0 5.4 5.4 0 12 0s12 5.4 12 12c0 5.94-4.32 10.86-10.02 11.88l-.66-.54h-2.64l-.66.54Z" fill="#fff" fill-opacity=".88"/>
      <path d="m16.68 15.36.54-3.36h-3.18V9.66c0-.96.36-1.68 1.8-1.68h1.56V4.92c-.84-.12-1.8-.24-2.64-.24-2.76 0-4.68 1.68-4.68 4.68V12h-3v3.36h3v8.46a11.048 11.048 0 0 0 3.96 0v-8.46h2.64Z" fill="#01374e"/>
    </svg>
  `,
    twitter: `
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" fill="none">
      <path d="M19,1.2h3.7l-8.1,9.2L24,22.8h-7.4l-5.8-7.6l-6.6,7.6H0.5L9,13L0,1.2h7.6l5.2,6.9L19,1.2z M17.7,20.7h2L6.5,3.2
        H4.3L17.7,20.7z" fill="#fff" fill-opacity=".88"/>
    </svg>
    `,
    instagram: `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.004 0c-5.01 0-6.475.005-6.76.029-1.028.085-1.668.247-2.365.594A4.79 4.79 0 0 0 1.5 1.633C.74 2.423.278 3.396.11 4.553c-.08.56-.104.675-.11 3.542v3.9c0 5.008.006 6.472.03 6.756.083 1 .24 1.63.573 2.319a5.056 5.056 0 0 0 3.276 2.677c.495.128 1.04.198 1.742.23.297.014 3.326.023 6.357.023s6.062-.004 6.352-.018c.812-.039 1.283-.102 1.805-.237a5.022 5.022 0 0 0 3.276-2.683c.326-.672.491-1.325.566-2.274.016-.206.023-3.503.023-6.796s-.007-6.584-.024-6.79c-.075-.964-.24-1.612-.577-2.297a4.76 4.76 0 0 0-1.027-1.408C21.578.739 20.607.277 19.45.11c-.56-.081-.672-.105-3.54-.11h-3.906Z" fill="#fff" fill-opacity=".88"/>
      <path d="M11.999 3.14c-2.406 0-2.708.011-3.653.054-.944.043-1.587.193-2.15.412a4.338 4.338 0 0 0-1.57 1.022 4.35 4.35 0 0 0-1.023 1.57c-.22.563-.369 1.207-.411 2.15-.042.946-.054 1.248-.054 3.655s.011 2.708.054 3.653c.043.944.193 1.588.412 2.151a4.337 4.337 0 0 0 1.021 1.57c.493.493.987.797 1.57 1.023.563.22 1.207.369 2.15.412.945.043 1.247.053 3.653.053 2.406 0 2.707-.01 3.652-.053.944-.044 1.588-.193 2.152-.412a4.335 4.335 0 0 0 1.568-1.023 4.35 4.35 0 0 0 1.023-1.57c.218-.563.367-1.207.412-2.15.042-.946.053-1.247.053-3.654s-.011-2.709-.053-3.654c-.045-.944-.194-1.588-.412-2.151a4.35 4.35 0 0 0-1.023-1.57 4.33 4.33 0 0 0-1.569-1.022c-.564-.22-1.209-.369-2.152-.412-.945-.043-1.246-.053-3.653-.053H12Zm-.795 1.598H12c2.365 0 2.646.008 3.58.05.864.04 1.333.185 1.645.306.413.16.708.352 1.018.663.31.31.502.605.663 1.019.121.312.266.78.305 1.645.043.934.052 1.215.052 3.58s-.01 2.646-.052 3.58c-.04.864-.184 1.333-.305 1.645a2.74 2.74 0 0 1-.663 1.018 2.74 2.74 0 0 1-1.018.663c-.312.122-.781.266-1.645.305-.934.043-1.215.052-3.58.052-2.366 0-2.646-.01-3.58-.052-.864-.04-1.333-.184-1.645-.305a2.744 2.744 0 0 1-1.02-.663 2.747 2.747 0 0 1-.662-1.019c-.122-.312-.266-.78-.305-1.645-.043-.934-.051-1.215-.051-3.581 0-2.367.008-2.646.05-3.58.04-.864.184-1.333.306-1.646.16-.413.353-.709.663-1.019a2.75 2.75 0 0 1 1.019-.663c.312-.122.78-.266 1.645-.306.817-.037 1.134-.048 2.785-.05v.003Zm5.524 1.471a1.063 1.063 0 1 0 0 2.126 1.063 1.063 0 0 0 0-2.126Zm-4.73 1.243a4.55 4.55 0 1 0 .003 9.101 4.55 4.55 0 0 0-.002-9.101Zm0 1.597a2.954 2.954 0 1 1 0 5.907 2.954 2.954 0 0 1 0-5.907Z" fill="#01374e"/>
    </svg>

    `,
    youtube: `
    <svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M33.39 3.748A4.282 4.282 0 0 0 30.375.717C27.715 0 17.051 0 17.051 0S6.387 0 3.728.717a4.282 4.282 0 0 0-3.015 3.03C0 6.423 0 12 0 12s0 5.579.713 8.253a4.282 4.282 0 0 0 3.015 3.03C6.388 24 17.05 24 17.05 24s10.665 0 13.324-.716a4.283 4.283 0 0 0 3.015-3.031c.713-2.675.713-8.253.713-8.253s0-5.578-.713-8.252Z" fill="#fff" fill-opacity=".88"/>
      <path d="M13.563 17.063 22.476 12l-8.913-5.065v10.13Z" fill="#01374e"/>
    </svg>
    `,
  };

  render(): TemplateResult {
    return html`
    <outline-link
        link-href="https://twitter.com/the_IDB"
        link-target="_blank"
        link-aria-label="Twitter"
      >
        ${unsafeSVG(this.icons.twitter) as SVGTemplateResult}
      </outline-link>
      <outline-link
        link-href="https://www.facebook.com/IADB.org"
        link-target="_blank"
        link-aria-label="Facebook"
      >
        ${unsafeSVG(this.icons.facebook) as SVGTemplateResult}
      </outline-link>
      <outline-link
        link-href="https://www.instagram.com/el_bid/"
        link-target="_blank"
        link-aria-label="Instagram"
      >
        ${unsafeSVG(this.icons.instagram) as SVGTemplateResult}
      </outline-link>
      <outline-link
        link-href="https://www.youtube.com/user/IDB"
        link-target="_blank"
        link-aria-label="YouTube"
      >
        ${unsafeSVG(this.icons.youtube) as SVGTemplateResult}
      </outline-link>
    `;
  }
}
